import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { usePopper } from 'react-popper';
import CustomDropdownItem from './CustomDropdownItem';
import './CustomDropdownMenu.css';

const DropdownMenu = ({ isPopperOpen, setPopperOpen, optionsRef, popOverId, sections }) => {
  const popperRef = useRef(null);

  const { styles, update: updatePopper } = usePopper(optionsRef.current, popperRef.current, {
    placement: 'bottom',
    modifiers: [
      {
        name: 'computeStyles',
        options: {
          adaptive: false,
        },
      },
    ],
  });

  // logic for handling when user clicks outside of popover
  useEffect(() => {
    function handleDocumentClick(event) {
      if (!event.target.id.includes(`pop-over-${popOverId}`)) {
        setPopperOpen(false);
      }
    }

    window.addEventListener('click', handleDocumentClick, false);
    return () => window.removeEventListener('click', handleDocumentClick, false);
  }, [setPopperOpen, popOverId]);

  useEffect(() => {
    if (updatePopper) updatePopper();
  }, [isPopperOpen, updatePopper]);

  return (
    <div ref={popperRef} style={styles.popper} className="pop-over-ref">
      {isPopperOpen && (
        <div className="pop-over-container">
          {sections.map((section) =>
            section.map(({ label, onClick, style }, index) => (
              <CustomDropdownItem
                key={label}
                label={label}
                onClick={() => {
                  if (onClick) {
                    onClick();
                    setPopperOpen(false);
                  }
                }}
                popOverId={popOverId}
                index={index}
                style={style}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
};

DropdownMenu.defaultProps = { sections: [[{ label: 'No Options Available' }]] };

DropdownMenu.propTypes = {
  isPopperOpen: PropTypes.bool.isRequired,
  setPopperOpen: PropTypes.func.isRequired,
  optionsRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  // popover id must be added to popover trigger button for click away logic
  // naming convention: 'pop-over-{popOverId}'
  popOverId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  // sections example:
  // [
  //    [{ label: {string or html}, onClick: {function]} }],
  // ]
  sections: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        onClick: PropTypes.func,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      })
    )
  ),
};

export default DropdownMenu;
